module.exports = {
  "siteMetadata": {
    "title": "Hearsall Community Academy",
    "description": "Welcome to Hearsall Community Academy",
    "author": "@accrosoft",
    "siteUrl": "https://hearsallacademy.org/",
    "defaultSiteImage": "https://cdn2.accropress.com/content-uploads/5cac3247-b599-459f-8c1c-47ab12db7578/global/pElhEkP1RCqGQ5d7E1OT_hearsall-logo.png",
    "siteLogo": "https://cdn2.accropress.com/content-uploads/5cac3247-b599-459f-8c1c-47ab12db7578/global/pElhEkP1RCqGQ5d7E1OT_hearsall-logo.png",
    "siteAvatar": "https://cdn2.accropress.com/content-uploads/5cac3247-b599-459f-8c1c-47ab12db7578/global/pElhEkP1RCqGQ5d7E1OT_hearsall-logo.png",
    "theme_color": null,
    "lang": "en"
  },
  "plugins": [{
    "resolve": "gatsby-plugin-accropress",
    "options": {
      "integrator": {
        "id": "2313514f-0657-48f1-a3ba-f72d27f82f37",
        "accessToken": "764b9120-0f1e-4267-b0b3-f6f531e2993c",
        "redirectURL": "https://hearsallacademy.org/"
      },
      "siteIDId": "c7f8601c-a14d-45cc-a70b-c278020133a9",
      "site": {
        "id": "c7f8601c-a14d-45cc-a70b-c278020133a9",
        "title": "Hearsall Community Academy",
        "description": "Welcome to Hearsall Community Academy",
        "careersPageURL": null,
        "careersPageVacancyURL": null,
        "siteUrl": "https://hearsallacademy.org/",
        "siteOwnerId": "89f85076-ce9e-4515-8880-f4d8b9988bf6",
        "siteTypeId": null,
        "deploymentsId": "7d90c7c4-d3b3-46a8-a917-2dd9b4b5eb80",
        "smartfeedSettingsId": null,
        "weducSettingsId": "fb50a4af-381d-4585-95f8-9f31c55b298e",
        "useCustomContactForm": false,
        "isNovaSite": false,
        "novaSiteID": null,
        "novaCompanyIDs": [],
        "novaGroupIDs": [],
        "smartFeedID": null,
        "tenantUrl": "hearsall-community-academy",
        "author": "@accrosoft",
        "defaultSiteImage": "https://cdn2.accropress.com/content-uploads/5cac3247-b599-459f-8c1c-47ab12db7578/global/pElhEkP1RCqGQ5d7E1OT_hearsall-logo.png",
        "siteLogo": "https://cdn2.accropress.com/content-uploads/5cac3247-b599-459f-8c1c-47ab12db7578/global/pElhEkP1RCqGQ5d7E1OT_hearsall-logo.png",
        "siteAvatar": "https://cdn2.accropress.com/content-uploads/5cac3247-b599-459f-8c1c-47ab12db7578/global/pElhEkP1RCqGQ5d7E1OT_hearsall-logo.png",
        "theme_color": null,
        "lang": "en",
        "tagManagerID": null,
        "googleAnalyticsID": null,
        "googleMapKey": null,
        "useGoogleJavascriptMaps": false,
        "useGoogleGeocodingMaps": false,
        "useGoogleEmbedMaps": false,
        "email_url": null,
        "twitter_url": null,
        "facebook_url": null,
        "nova_page_slug": null,
        "nova_page_id": null,
        "company_thumbnail": null,
        "company_hero": null,
        "company_video": null,
        "company_primary_colour": null,
        "company_primary_colour_hover": null,
        "company_secondary_colour": null,
        "company_secondary_colour_hover": null
      },
      "siteSettings": {
        "id": "d9e83f8a-48c0-4c4f-a956-09e339791f91",
        "themeSettingsPayload": [{
          "children": [{
            "id": "logo-image",
            "name": "Logo Image",
            "type": "image",
            "value": "https://cdn2.accropress.com/c7f8601c-a14d-45cc-a70b-c278020133a9/media/c7f8601c-a14d-45cc-a70b-c278020133a9/90af62cf-f334-4d45-92ec-6cef4f60d1bb_full_full_logo_-_hearsall.png",
            "width": "100",
            "columns": "",
            "default": "https://demo-7.weduc.website/logo.png",
            "groupID": "basic-settings"
          }, {
            "id": "school-name-title",
            "name": "School Name Title",
            "type": "input",
            "value": "Hearsall Community Academy",
            "width": "100",
            "columns": "",
            "default": "Weduc Academy",
            "groupID": "basic-settings"
          }, {
            "id": "school-name-subtitle",
            "name": "School Name Subtitle",
            "type": "input",
            "width": "100",
            "columns": "",
            "default": "Demo School",
            "groupID": "basic-settings"
          }, {
            "id": "theme-font-settings",
            "name": "Theme font settings",
            "type": "dropdown",
            "width": "100",
            "columns": "",
            "default": [{
              "name": "Poppins",
              "value": "Poppins",
              "fontFamily": "Poppins"
            }],
            "hiddenField": true
          }, {
            "id": "theme-colour-settings",
            "name": "Theme Colour Settings",
            "type": "group",
            "width": "100",
            "columns": [{
              "id": "theme-colour-settings-primary",
              "name": "Primary Colour",
              "type": "colour",
              "default": "#1fbdb7",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "theme-colour-settings-secondary",
              "name": "Secondary Colour",
              "type": "colour",
              "default": "#2d3e50",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "background",
              "name": "Background",
              "type": "colour",
              "default": "transparent",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "text-color",
              "name": "Text Colour",
              "type": "colour",
              "default": "#000",
              "maximum": 0,
              "minimum": 0
            }],
            "default": "",
            "groupID": "colour-settings",
            "children": [[{
              "id": "theme-colour-settings-primary",
              "name": "Primary Colour",
              "type": "colour",
              "color": "#37342f",
              "default": "#1fbdb7",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "theme-colour-settings-secondary",
              "name": "Secondary Colour",
              "type": "colour",
              "color": "#D94438",
              "default": "#2d3e50",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "background",
              "name": "Background",
              "type": "colour",
              "default": "transparent",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "text-color",
              "name": "Text Colour",
              "type": "colour",
              "default": "#000",
              "maximum": 0,
              "minimum": 0
            }]]
          }, {
            "id": "home-banner-settings",
            "name": "Hero Banner Settings",
            "type": "group",
            "width": "100",
            "columns": [{
              "id": "home-banner-settings-image",
              "name": "Default Hero Image",
              "type": "input",
              "default": "https://cdn2.accropress.com/4953d6eb-4231-4cc5-bfeb-f429d19efc1b/c59afd92-2ba0-42f9-bdd2-69453ca150b4.jpeg",
              "maximum": 0,
              "minimum": 0
            }],
            "default": "",
            "groupID": "hero-banner-settings",
            "children": [[{
              "id": "home-banner-settings-image",
              "name": "Default Hero Image",
              "type": "input",
              "default": "https://cdn2.accropress.com/4953d6eb-4231-4cc5-bfeb-f429d19efc1b/c59afd92-2ba0-42f9-bdd2-69453ca150b4.jpeg",
              "maximum": 0,
              "minimum": 0
            }]]
          }, {
            "id": "weduc-widgets-settings",
            "name": "Weduc Widgets Settings",
            "type": "group",
            "width": "100",
            "columns": [{
              "id": "weduc-widgets-settings-websitesid",
              "name": "Weduc Websites ID",
              "type": "input",
              "default": "weducdemositeuser",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "weduc-widgets-settings-containerid",
              "name": "Weduc Main Container ID",
              "type": "input",
              "default": "281474976810657",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "weduc-widgets-settings-entityid",
              "name": "Weduc Main Entity ID",
              "type": "input",
              "default": "281474976810657",
              "maximum": 0,
              "minimum": 0
            }],
            "default": "",
            "groupID": "weduc-widgets-settings",
            "children": [[{
              "id": "weduc-widgets-settings-websitesid",
              "name": "Weduc Websites ID",
              "type": "input",
              "default": "weducdemositeuser",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "weduc-widgets-settings-containerid",
              "name": "Weduc Main Container ID",
              "type": "input",
              "value": "281474977034150",
              "default": "281474976810657",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "weduc-widgets-settings-entityid",
              "name": "Weduc Main Entity ID",
              "type": "input",
              "value": "281474976815844",
              "default": "281474976810657",
              "maximum": 0,
              "minimum": 0
            }]]
          }]
        }],
        "menusPayload": [],
        "widgetsPayload": [{
          "children": [{
            "id": "footer-contact-details",
            "name": "Contact Details",
            "type": "group",
            "width": "100",
            "columns": [{
              "id": "footer-contact-details-ad1",
              "name": "Address Line One",
              "type": "input",
              "default": "Weduc Academy",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "footer-contact-details-ad2",
              "name": "Address Line Two",
              "type": "input",
              "default": "21 Jubilee Drive Loughborough",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "footer-contact-details-ad3",
              "name": "Address Line Three",
              "type": "input",
              "default": "LE11 5XS United Kingdom",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "footer-contact-details-tel",
              "name": "Telephone Number",
              "type": "input",
              "default": "+ 44 (0)1509 221 349",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "footer-contact-details-email",
              "name": "Email Address",
              "type": "input",
              "default": " info@weduc.co.uk",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "footer-contact-details-insta",
              "name": "Instagram Link",
              "type": "input",
              "default": null,
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "footer-contact-details-facebook",
              "name": "Facebook Link",
              "type": "input",
              "default": null,
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "footer-contact-details-twitter",
              "name": "Twitter Link",
              "type": "input",
              "default": null,
              "maximum": 0,
              "minimum": 0
            }],
            "default": "",
            "children": [[{
              "id": "footer-contact-details-ad1",
              "name": "Address Line One",
              "type": "input",
              "value": "Hearsall Community Academy",
              "default": "Weduc Academy",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "footer-contact-details-ad2",
              "name": "Address Line Two",
              "type": "input",
              "value": "Kingston Road, Coventry,",
              "default": "21 Jubilee Drive Loughborough",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "footer-contact-details-ad3",
              "name": "Address Line Three",
              "type": "input",
              "value": "West Midlands, CV5 6LR",
              "default": "LE11 5XS United Kingdom",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "footer-contact-details-tel",
              "name": "Telephone Number",
              "type": "input",
              "value": "024 7667 4625",
              "default": "+ 44 (0)1509 221 349",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "footer-contact-details-email",
              "name": "Email Address",
              "type": "input",
              "value": "admin@hearsallacademy.org",
              "default": "info@weduc.co.uk",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "footer-contact-details-insta",
              "name": "Instagram Link",
              "type": "input",
              "default": "",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "footer-contact-details-facebook",
              "name": "Facebook Link",
              "type": "input",
              "default": "",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "footer-contact-details-twitter",
              "name": "Twitter Link",
              "type": "input",
              "default": "",
              "maximum": 0,
              "minimum": 0
            }]]
          }, {
            "id": "other-resources",
            "name": "Other Resources",
            "type": "group",
            "width": "100",
            "columns": [{
              "id": "footer-useful-links-item",
              "name": "Link Item",
              "type": "url",
              "default": "",
              "maximum": 0,
              "minimum": 0
            }],
            "default": "",
            "children": [[{
              "id": "footer-useful-links-item",
              "name": "Link Item",
              "type": "url",
              "default": "",
              "maximum": 0,
              "minimum": 0
            }]],
            "repeater": true
          }],
          "widgetID": "footer"
        }],
        "theme": {
          "id": "e9e85fbc-5a86-466f-b9ec-08f1e4e7bb84",
          "name": "Inspiration Weduc Websites Theme",
          "version": "1.0.0",
          "description": "A modern website theme, designed for multi academy trusts",
          "tags": [],
          "previewThumbnail": "https://website-screens.accropress.com/be683bce-273c-4b7d-b1d5-1f2fc9b392e5.png",
          "previewDomain": "https://demo-inspiration.weduc.website/",
          "themeSettingsDefinition": [{
            "children": [{
              "id": "logo-image",
              "name": "Logo Image",
              "type": "image",
              "width": "100",
              "columns": "",
              "default": "https://demo-7.weduc.website/logo.png",
              "groupID": "basic-settings"
            }, {
              "id": "school-name-title",
              "name": "School Name Title",
              "type": "input",
              "width": "100",
              "columns": "",
              "default": "Weduc Academy",
              "groupID": "basic-settings"
            }, {
              "id": "school-name-subtitle",
              "name": "School Name Subtitle",
              "type": "input",
              "width": "100",
              "columns": "",
              "default": "Demo School",
              "groupID": "basic-settings"
            }, {
              "id": "theme-font-settings",
              "name": "Theme font settings",
              "type": "dropdown",
              "width": "100",
              "columns": "",
              "default": [{
                "name": "Poppins",
                "value": "Poppins",
                "fontFamily": "Poppins"
              }],
              "hiddenField": true
            }, {
              "id": "theme-colour-settings",
              "name": "Theme Colour Settings",
              "type": "group",
              "width": "100",
              "columns": [{
                "id": "theme-colour-settings-primary",
                "name": "Primary Colour",
                "type": "colour",
                "default": "#1fbdb7",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "theme-colour-settings-secondary",
                "name": "Secondary Colour",
                "type": "colour",
                "default": "#2d3e50",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "background",
                "name": "Background",
                "type": "colour",
                "default": "transparent",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "text-color",
                "name": "Text Colour",
                "type": "colour",
                "default": "#000",
                "maximum": 0,
                "minimum": 0
              }],
              "default": "",
              "groupID": "colour-settings",
              "children": [[{
                "id": "theme-colour-settings-primary",
                "name": "Primary Colour",
                "type": "colour",
                "default": "#1fbdb7",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "theme-colour-settings-secondary",
                "name": "Secondary Colour",
                "type": "colour",
                "default": "#2d3e50",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "background",
                "name": "Background",
                "type": "colour",
                "default": "transparent",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "text-color",
                "name": "Text Colour",
                "type": "colour",
                "default": "#000",
                "maximum": 0,
                "minimum": 0
              }]]
            }, {
              "id": "home-banner-settings",
              "name": "Hero Banner Settings",
              "type": "group",
              "width": "100",
              "columns": [{
                "id": "home-banner-settings-image",
                "name": "Default Hero Image",
                "type": "input",
                "default": "https://cdn2.accropress.com/4953d6eb-4231-4cc5-bfeb-f429d19efc1b/c59afd92-2ba0-42f9-bdd2-69453ca150b4.jpeg",
                "maximum": 0,
                "minimum": 0
              }],
              "default": "",
              "groupID": "hero-banner-settings",
              "children": [[{
                "id": "home-banner-settings-image",
                "name": "Default Hero Image",
                "type": "input",
                "default": "https://cdn2.accropress.com/4953d6eb-4231-4cc5-bfeb-f429d19efc1b/c59afd92-2ba0-42f9-bdd2-69453ca150b4.jpeg",
                "maximum": 0,
                "minimum": 0
              }]]
            }, {
              "id": "weduc-widgets-settings",
              "name": "Weduc Widgets Settings",
              "type": "group",
              "width": "100",
              "columns": [{
                "id": "weduc-widgets-settings-websitesid",
                "name": "Weduc Websites ID",
                "type": "input",
                "default": "weducdemositeuser",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "weduc-widgets-settings-containerid",
                "name": "Weduc Main Container ID",
                "type": "input",
                "default": "281474976810657",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "weduc-widgets-settings-entityid",
                "name": "Weduc Main Entity ID",
                "type": "input",
                "default": "281474976810657",
                "maximum": 0,
                "minimum": 0
              }],
              "default": "",
              "groupID": "weduc-widgets-settings",
              "children": [[{
                "id": "weduc-widgets-settings-websitesid",
                "name": "Weduc Websites ID",
                "type": "input",
                "default": "weducdemositeuser",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "weduc-widgets-settings-containerid",
                "name": "Weduc Main Container ID",
                "type": "input",
                "default": "281474976810657",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "weduc-widgets-settings-entityid",
                "name": "Weduc Main Entity ID",
                "type": "input",
                "default": "281474976810657",
                "maximum": 0,
                "minimum": 0
              }]]
            }]
          }],
          "menusDefinition": [{
            "id": "primary-menu",
            "name": "Primary Menu",
            "children": [],
            "automatic-menu": true
          }],
          "widgetsDefinition": [{
            "children": [{
              "id": "footer-contact-details",
              "name": "Contact Details",
              "type": "group",
              "width": "100",
              "columns": [{
                "id": "footer-contact-details-ad1",
                "name": "Address Line One",
                "type": "input",
                "default": "Weduc Academy",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-ad2",
                "name": "Address Line Two",
                "type": "input",
                "default": "21 Jubilee Drive Loughborough",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-ad3",
                "name": "Address Line Three",
                "type": "input",
                "default": "LE11 5XS United Kingdom",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-tel",
                "name": "Telephone Number",
                "type": "input",
                "default": "+ 44 (0)1509 221 349",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-email",
                "name": "Email Address",
                "type": "input",
                "default": " info@weduc.co.uk",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-insta",
                "name": "Instagram Link",
                "type": "input",
                "default": null,
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-facebook",
                "name": "Facebook Link",
                "type": "input",
                "default": null,
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-twitter",
                "name": "Twitter Link",
                "type": "input",
                "default": null,
                "maximum": 0,
                "minimum": 0
              }],
              "default": "",
              "children": [[{
                "id": "footer-contact-details-ad1",
                "name": "Address Line One",
                "type": "input",
                "default": "Weduc Academy",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-ad2",
                "name": "Address Line Two",
                "type": "input",
                "default": "21 Jubilee Drive Loughborough",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-ad3",
                "name": "Address Line Three",
                "type": "input",
                "default": "LE11 5XS United Kingdom",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-tel",
                "name": "Telephone Number",
                "type": "input",
                "default": "+ 44 (0)1509 221 349",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-email",
                "name": "Email Address",
                "type": "input",
                "default": "info@weduc.co.uk",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-insta",
                "name": "Instagram Link",
                "type": "input",
                "default": "",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-facebook",
                "name": "Facebook Link",
                "type": "input",
                "default": "",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-twitter",
                "name": "Twitter Link",
                "type": "input",
                "default": "",
                "maximum": 0,
                "minimum": 0
              }]]
            }, {
              "id": "other-resources",
              "name": "Other Resources",
              "type": "group",
              "width": "100",
              "columns": [{
                "id": "footer-useful-links-item",
                "name": "Link Item",
                "type": "url",
                "default": "",
                "maximum": 0,
                "minimum": 0
              }],
              "default": "",
              "children": [[{
                "id": "footer-useful-links-item",
                "name": "Link Item",
                "type": "url",
                "default": "",
                "maximum": 0,
                "minimum": 0
              }]],
              "repeater": true
            }],
            "widgetID": "footer"
          }],
          "templates": []
        }
      }
    }
  }, "gatsby-plugin-react-helmet", {
    "resolve": "gatsby-plugin-s3",
    "options": {
      "bucketName": "null-bucket.accropress.com",
      "mergeCachingParams": true,
      "generateRoutingRules": true,
      "generateRedirectObjectsForPermanentRedirects": false,
      "generateIndexPageForRedirect": true,
      "generateMatchPathRewrites": true,
      "removeNonexistentObjects": true,
      "enableS3StaticWebsiteHosting": false
    }
  }, "gatsby-plugin-sass", {
    "resolve": "gatsby-source-filesystem",
    "options": {
      "name": "images",
      "path": "./src/images"
    }
  }, {
    "resolve": "gatsby-plugin-react-leaflet",
    "options": {
      "linkStyles": true
    }
  }, "gatsby-transformer-sharp", "gatsby-plugin-sharp", {
    "resolve": "gatsby-plugin-sitemap",
    "options": {
      "output": "/sitemap-pages.xml"
    }
  }, {
    "resolve": "gatsby-plugin-seo",
    "options": {
      "siteName": "Hearsall Community Academy",
      "defaultSiteImage": "https://cdn2.accropress.com/content-uploads/5cac3247-b599-459f-8c1c-47ab12db7578/global/pElhEkP1RCqGQ5d7E1OT_hearsall-logo.png",
      "siteUrl": "https://hearsallacademy.org/",
      "globalSchema": "{\n                  \"@type\": \"WebSite\",\n                  \"url\": https://hearsallacademy.org/,\n                  \"name\": Hearsall Community Academy,\n                  \"image\": {\n                    \"@type\": \"ImageObject\",\n                    \"url\": https://cdn2.accropress.com/content-uploads/5cac3247-b599-459f-8c1c-47ab12db7578/global/pElhEkP1RCqGQ5d7E1OT_hearsall-logo.png,\n                    \"caption\": Hearsall Community Academy\n                  }\n                }"
    }
  }, {
    "resolve": "gatsby-plugin-manifest",
    "options": {
      "name": "Hearsall Community Academy",
      "short_name": "Hearsall Community Academy",
      "start_url": "/",
      "background_color": "#fff",
      "theme_color": "#000",
      "display": "standalone",
      "icon": "static/img/apple-icon.png"
    }
  }, {
    "resolve": "@accrosoft-ltd/gatsby-plugin-use-dark-mode",
    "options": {
      "classNameDark": "dark-mode",
      "classNameLight": "light-mode",
      "storageKey": "darkMode",
      "minify": true,
      "usePrefersColorScheme": false
    }
  }]
};